// extracted by mini-css-extract-plugin
export default {"img":"PieceRendererViewOriginalImageData_img__+8Jy+"};